<ng-container *transloco="let t">
  <div class="modal-header">

    <h2>{{ t('wizard.personalInfo.title') }}</h2>

    <!-- hack to fool ngbModal autofocus -->
    <input type="text" style="display:none" />

    <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" [attr.aria-label]="t('common.close')"
      (click)="activeModal.dismiss('Cross click')">
      <span class="svg-icon svg-icon-2x">
        <close-x-svg-icon></close-x-svg-icon>
      </span>
    </div>
  </div>

  <div class="modal-body py-10 px-lg-17">
    <form #personalInfoForm="ngForm" class="form" novalidate id="personalInfoForm" name="personalInfoForm">
      <div class="me-n7 pe-7">
        <div class="row mb-5">
          <div class="col-md-6 fv-row">
            <label class="required form-label mb-2">{{ t('wizard.myInfo.firstName') }}</label>
            <input type="text" class="form-control form-control-solid"
              [ngClass]="{'is-invalid' : firstName && firstName.touched && firstName.invalid}" #firstName="ngModel"
              [(ngModel)]="borrower.firstName" placeholder="" name="firstName" required />
            <div class="invalid-feedback">{{ t('wizard.personalInfo.firstNameRequired') }}</div>
          </div>
          <div class="col-md-6 fv-row">
            <label class="required form-label mb-2">{{ t('wizard.myInfo.lastName') }}</label>
            <input type="text" class="form-control form-control-solid"
             [ngClass]="{'is-invalid' : lastName && lastName.touched && lastName.invalid}" #lastName="ngModel"
             [(ngModel)]="borrower.lastName" placeholder="" name="lastName" required />
           <div class="invalid-feedback">{{ t('wizard.personalInfo.lastNameRequired') }}</div>
          </div>
        </div>

        <div class="row mb-5">
          <div class="col-md-6 fv-row">
            <label class="required form-label mb-2">{{ t('wizard.myInfo.maritalStatus') }}</label>
            <select class="form-select form-select-solid" data-control="select2" name="maritalStatus"
            [(ngModel)]="borrower.maritalStatus" #maritalStatus="ngModel" required
            [ngClass]="{'is-invalid' : maritalStatus && maritalStatus.touched && maritalStatus.invalid}">
            <option value="">{{ t('common.selectOne') }}</option>
            <option value="Single">{{ t('enums.maritalStatus.Single') }}</option>
            <option value="Married">{{ t('enums.maritalStatus.Married') }}</option>
            <option value="Separated">{{ t('enums.maritalStatus.Separated') }}</option>
            <option value="Other">{{ t('enums.maritalStatus.Other') }}</option>
             </select>
            <div class="invalid-feedback">{{ t('wizard.personalInfo.pleaseSelectValue') }}</div>
          </div>
          <div class="col-md-6 fv-row">
            <label class="required form-label">{{ t('wizard.myInfo.phoneNumber') }}</label>
             <div class="position-relative d-flex align-items-center">
               <input class="form-control form-control-solid"  placeholder="" mask='(000) 000-0000'
                  #phoneNumber="ngModel" required
                  [(ngModel)]="borrower.mobilePhone" name="phoneNumber" ngControl="phoneNumber" id="phoneNumber"
                 [ngClass]="{'is-invalid' : phoneNumber && phoneNumber.touched && phoneNumber.invalid}" />
                 <div class="invalid-feedback">{{ t('wizard.personalInfo.phoneRequired') }}</div>
            </div>
          </div>
        </div>

        <div class="row">
          <address [address]="address"></address>
        </div>

        <div class="row g-9 mb-5">
          <div class="col-md-6 fv-row">
            <label class="required form-label">{{ t('wizard.myInfo.ssn') }}</label>
            <div class="position-relative d-flex align-items-center">
              <input class="form-control form-control-solid" matInput mask="000-00-0000" [showMaskTyped]="true"
                [(ngModel)]="borrower.socialSecNum" #socialSecNum="ngModel" [specialCharacters]="[ '-' ]"
                [dropSpecialCharacters]="false" [patterns]="ssnPattern" [placeholder]="t('wizard.myInfo.ssn')" name="ssn"
                required [ngClass]="{'is-invalid' : socialSecNum && socialSecNum.touched && socialSecNum.invalid}" />
                <div class="invalid-feedback">{{ t('wizard.personalInfo.ssnRequired') }}</div>
            </div>
          </div>
          <div class="col-md-6 fv-row">
            <label class="required form-label">{{ t('wizard.myInfo.birthDate') }}</label>
            <div class="position-relative d-flex align-items-center">
              <input class="form-control form-control-solid" matInput mask="00/00/0000" [showMaskTyped]="true" inputmode="numeric"
               [specialCharacters]="[ '/' ]" [dropSpecialCharacters]="false" datePicker #birthDate="ngModel" required
                [(ngModel)]="borrower.dateOfBirth" placeholder="" inputmode="numeric" name="birthDate" ngControl="birthDate" id="birthDate"
                [ngClass]="{'is-invalid' : birthDate && birthDate.touched && birthDate.invalid}" />
              <div class="invalid-feedback">{{ t('wizard.personalInfo.birthDateRequired') }}</div>
            </div>
          </div>
        </div>
        <div>
          <div class="row g-9 mb-5">
            <div class="col-md-6 fv-row">
              <label class="required form-label">{{ t('wizard.myInfo.citizenship') }}</label>
              <select class="form-select form-select-solid" required data-control="select2" name="citizenship"
                [(ngModel)]="borrower.declarations!.residenceStatus!" #residenceStatus="ngModel"
                 [ngClass]="{'is-invalid' : residenceStatus && residenceStatus.touched && residenceStatus.invalid}">
                 <option value="" disabled>{{ t('common.selectOne') }}</option>
                 <option value="USCitizen">{{ t('enums.residenceStatus.USCitizen') }}</option>
                 <option value="PermanentResident">{{ t('enums.residenceStatus.PermanentResident') }}</option>
                 <option value="NonPermanentResidentAlien">{{ t('enums.residenceStatus.NonPermanentResidentAlien') }}</option>
               </select>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer flex-center">
    <button type="button" class="btn btn-white me-3" (click)="activeModal.dismiss()">{{ t('common.cancel') }}</button>
    <button type="button" class="btn btn-primary" (click)="onSaveClicked()">{{ t('common.ok') }}</button>
  </div>
</ng-container>
